import React, { useRef } from 'react';

import ReactDOM, { createPortal } from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';

import Popup from 'components/shared/Popup';
import { isChildOfParent } from 'utils/common';

export function useFormFieldPopup(popupLineName = 'popupLine') {
  const mountPointRef = useRef(null);
  const popupRef = useRef(null);
  const focusedRef = useRef(null);

  const handlePopupRender = () => {
    document.addEventListener('click', outsideClick);
  };
  const outsideClick = (evt) => {
    if (
      popupRef.current !== null &&
      !isChildOfParent(evt.target, popupRef.current) &&
      !isChildOfParent(evt.target, focusedRef.current) &&
      mountPointRef.current !== null
    ) {
      clear();
    }
  };
  const clear = () => {
    ReactDOM.unmountComponentAtNode(mountPointRef.current);

    document.removeEventListener('click', outsideClick);
  };

  return (content) => {
    return (evt) => {
      focusedRef.current = evt.target;

      if (mountPointRef.current !== null && mountPointRef.current.children.length) {
        clear();
      }

      mountPointRef.current = document.querySelector('.' + popupLineName);
      const { top: mountPointTop } = mountPointRef.current.getBoundingClientRect();
      const { top: inputTop } = evt.target.getBoundingClientRect();
      const top = inputTop - mountPointTop;

      ReactDOM.render(
        <Popup content={content} top={top} ref={popupRef} onRender={handlePopupRender} />,
        mountPointRef.current,
      );
    };
  };
}

export function FormFieldControlledTooltip({ isOpen, anchorRef, onClose, content }) {
  if (!isOpen || !anchorRef?.current) {
    return null;
  }

  const mountEl = document.querySelector('.controlledPopupLine');
  const anchorRect = anchorRef.current.getBoundingClientRect();
  const mountRect = mountEl.getBoundingClientRect();

  return createPortal(
    <OutsideClickHandler
      onOutsideClick={() => {
        if (onClose) onClose();
      }}
      display="contents"
    >
      <Popup content={content} top={anchorRect.top - mountRect.top} />
    </OutsideClickHandler>,
    mountEl,
  );
}
